export const iconFontAwesomeShoppingGooglePay = (
	<i className="fa-solid fa-google-pay"></i>
);
